import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { ListProductsOrderByEnum, ProductWithVariants } from '../openapi';
import { ProductClient } from '../clients/products';
import { typesense } from '../clients/typesense';

export type ProductParams = {
  orgId?: string;
  productId?: string;
  orderBy?: ListProductsOrderByEnum;
  limit?: number;
  brandId?: string[];
  categories?: string[];
  search?: string;
};

export const useProductByIdQuery = (
  params: ProductParams,
  options?: UseQueryOptions<ProductWithVariants>
): UseQueryResult<ProductWithVariants> =>
  useQuery({
    queryKey: ['productById', params.productId],
    queryFn: () =>
      (params.orgId &&
        params.productId &&
        ProductClient.getProduct(params.orgId, params.productId).then(
          ({ data }) => data
        )) ||
      ({} as ProductWithVariants),
    ...options,
  });

// typesense
export const searchProducts = async (query: string, page?: number) =>
  typesense.collections('Products').documents().search({
    q: query,
    query_by:
      'data.title,data.description,data.categories,data.variants.title,data.variants.gtin',
    limit: 10,
    page,
  });

export const filterProducts = async (
  brandIds: string[],
  categoryIds: string[],
  page?: number
) =>
  typesense
    .collections('Products')
    .documents()
    .search({
      q: '*',
      filter_by: [
        brandIds.length && `data.brand_id:=${brandIds.join(',')}`,
        categoryIds.length &&
          `data.google_product_category.id:=${categoryIds.join(',')}`,
      ]
        .filter((v) => v !== 0)
        .join(','),
      query_by:
        'data.title,data.description,data.categories,data.variants.title,data.variants.gtin',
      limit: 10,
      page,
    });
